<template>
    <div v-if="!selectedCategory" class="home web-page sf-scope enter-content-animation" :class="`sf-home sf-home--${storefront.template}`">
      <StoreCover v-if="storefront.settings.headerStyle === 'cover'" />
      <component
        v-for="section in enabledSections"
        :key="section.id"
        :is="sectionComponents[section.type]"
        :section="section"
        @open-product="setModalProduct"
      />

      <ProductModal :setSelectedProduct="(value: any) => selectedProduct = value" :setSelectedProductVariations="(value: string) => selectedProduct.variations = value" :isOpen="isProductModalOpen" :toggleModal="toggleProductModal" :selectedProduct="selectedProduct"></ProductModal>
    </div>
    <CategoriesShow v-else :id="selectedCategory.id" :category="selectedCategory" :setCategory="(value: any) => selectedCategory = value" />
</template>

<script lang="ts">
import { onMounted, ref, computed } from 'vue';
import { restaurant, categories } from '@/global/state/GlobalState';
import { storefront, StorefrontSection, StorefrontSectionType } from '@/global/state/StorefrontState';
import { useCategory } from '@/composables/useCategory'
import ProductModal from '@/components/modal/ProductModal.vue';
import CategoriesShow from '../categories/CategoriesShow.vue';
import AnnouncementSection from '@/components/storefront/sections/AnnouncementSection.vue';
import BannersSection from '@/components/storefront/sections/BannersSection.vue';
import CategoriesSection from '@/components/storefront/sections/CategoriesSection.vue';
import InfoSection from '@/components/storefront/sections/InfoSection.vue';
import FeaturedProductsSection from '@/components/storefront/sections/FeaturedProductsSection.vue';
import ImageTextSection from '@/components/storefront/sections/ImageTextSection.vue';
import MenuSection from '@/components/storefront/sections/MenuSection.vue';
import StoreCover from '@/components/storefront/StoreCover.vue';

const sectionComponents: Record<StorefrontSectionType, any> = {
  announcement: AnnouncementSection,
  banners: BannersSection,
  categories: CategoriesSection,
  info: InfoSection,
  featured_products: FeaturedProductsSection,
  image_text: ImageTextSection,
  menu: MenuSection,
}

export default {
  name: 'home-page',
  components: {
    ProductModal,
    CategoriesShow,
    StoreCover
  },
  setup() {
      const isProductModalOpen = ref<boolean>(false)
      const isCategoriesLoading = ref<boolean>(true)
      const selectedProduct = ref<any>({})
      const selectedCategory = ref<any>(null)

      const enabledSections = computed<StorefrontSection[]>(() =>
        storefront.value.sections.filter((section) => section.enabled && sectionComponents[section.type])
      )

      const setModalProduct = (product: any) => {
        selectedProduct.value = product
        isProductModalOpen.value = !isProductModalOpen.value
      }

      function toggleProductModal(isOpen: boolean){
        isProductModalOpen.value = isOpen
      }

      onMounted(() => {
        if(!categories.value){
          isCategoriesLoading.value = true
          const { listCategories, categories: categoryList } = useCategory()

          listCategories({ perPage: 100 }).then(() => {
              categories.value = categoryList.value
              isCategoriesLoading.value = false
          }).catch(err => {
              console.error(err)
              isCategoriesLoading.value = false
          })
        }
      })

      return {
        sectionComponents,
        enabledSections,
        storefront,
        isProductModalOpen,
        setModalProduct,
        toggleProductModal,
        isCategoriesLoading,
        restaurant,
        selectedProduct,
        selectedCategory,
      };
    },
};
</script>

<style lang="scss">
  .home{
    .swiper-pagination-bullet.swiper-pagination-bullet-active{
       background-color: v-bind("restaurant.restaurantDesignCustom?.secondaryColor ?? '#ccc'") !important
    }

    .home__categories-list, .home__banners, .home__info {
      .swiper-slide.swiper-slide-next{
        display:flex;
        justify-content: center;
        align-items: center;
      }
    }

    .swiper.pb-10{
      padding-bottom:2.5rem
    }

    &__categories__item{
      margin-bottom:2rem;
    }
  }

  html.sf-dark .home .swiper-pagination-bullet {
    background-color: #71717a;
  }
</style>
